/***********************************
  Menu Module
************************************/

Quad.Menu = ( function() {

  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var Cookies = require( 'js-cookie' );

  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    var pageButtonText = acf_js_vars.search_page_button_text;
        locationHeader = acf_js_vars.search_location_header;
        resultsFound   = acf_js_vars.results_found_label;
        noResultsFound = acf_js_vars.no_results_found_label;

    $( '.main-nav-btn' ).click( function() {

      var menu = $( this ).data( 'menu' );

      if ( menu == 'search' ) {
        //load a previous search
        if ( !$( this ).hasClass( 'active' )) {
          var searchTerm = Cookies.get( 'search-term' );
          if ( searchTerm != '' && searchTerm != undefined ) {
            $( '#search-input' ).val( searchTerm );
            $( 'form.search' ).submit();
          }
        }
      }

      $( '.main-nav-btn, .menu-section' ).each( function() {

        $( this ).data( 'menu' ) === menu && $( this ).attr( 'id' ) !== 'walkthrough' ? $( this ).toggleClass( 'active' ) : $( this ).removeClass( 'active' );

      });

    });

    $( window ).scroll( function() {

      var pos = $( window ).scrollTop(),
        vh = $( window ).height();

      pos > vh ? $( '#scroll-top' ).addClass( 'active' ) : $( '#scroll-top' ).removeClass( 'active' );

    });

    var resizeSet;

    $( window ).resize( function() {

      $( '.menu-section' ).css( 'transition', 'none' );

      clearTimeout( resizeSet );

      resizeSet = setTimeout( function() {

        $( '.menu-section' ).removeAttr( 'style' );

      }, 150 );

    });

    $( '#scroll-top' ).click( function() {

      $( 'html,body' ).animate({ scrollTop: 0 }, 400 );

    });

    if ( $( '#head-teaser--pushdown' ) && !Cookies.get( 'pushdown-close' )) {

      setTimeout( function() {

        $( '#head-teaser--pushdown' ).slideDown();

      }, 500 );

    }

    $( '#close-pushdown' ).click( function() {

      Cookies.set( 'pushdown-close', true );
      $( '#head-teaser--pushdown' ).slideUp();

    });

    /*****************/
    /*   SEARCH.JS   */
    /*****************/

    var pagination = 0;

    var path = window.location.href.split( '/' );
    path = path[ 0 ] + '//' + path[ 2 ];

    $( 'form .clear' ).click( function( event ) {

      event.preventDefault();

      Cookies.remove( 'search-term' );

      $( this ).siblings( 'input' ).val( '' ).trigger( 'change' ).trigger( 'focus' );

      pagination = 0;

      $( '#menu-search-pagination' ).hide().removeAttr( 'data-val' );

      document.getElementById( 'menu-search-results' ).innerHTML = '';

    });

    $( 'form.search' ).submit( function( event ) {

      event.preventDefault();

      $( '#loading-search-results' ).show();

      var $val = $( this ).children( '#search-input' ).val();
      Cookies.set( 'search-term', $val );

      $.ajax({

        method: 'POST',
        url: path + '/wp-admin/admin-ajax.php',
        data: {
          query: $val,
          action: 'search_posts',
          security: $( '#search_nonce' ).val()
        },
        success: function( response ) {

          $( '#menu-search-pagination' ).attr( 'data-val', $val );

          $( '#loading-search-results' ).hide();

          document.getElementById( 'menu-search-results' ).innerHTML = '';

          var posts = response.data.posts;

          console.log( posts );

          if ( posts.length > 0 ) {

            $( '#menu-search-results' ).prepend( '<h3 class="results-found">'+ posts[ 0 ].grand_total +
                                                   ' ' + resultsFound +':</h3>' );

            for ( var i = 0; i < posts.length; i++ ) {

              var $date = posts[ i ].date,
                $title = posts[ i ].title,
                $href = posts[ i ].href,
                $excerpt = posts[ i ].excerpt,
                $img = posts[ i ].img,
                $template = posts[ i ].template,
                $isLocation = posts[ i ].template === 'location.php' ? '<h6 class="eyebrow">' + locationHeader + '</h6>' : '';

              $( '#menu-search-results' ).addClass( 'contains-results' ).append(

                '<div class="menu-search-result tile match-height" data-pagination="' + pagination + '">' +
                $isLocation +
                '<h4>' + $title + '</h4>' +
                '<p>' + $excerpt + '</p>' +
                '<a class="cta btn" href="'+ $href +'"><span class="icon-right-circle"></span>' + pageButtonText + '</a>' +
                '</div>'

              );

            }

            var $results = $( '.menu-search-result' );

            $results
              .each( function( index ) {
                var that = this;
                setTimeout( function() {
                  $( that ).addClass( 'fadein' );
                }, ( index + 1 ) * 100 );
              })
              .equalHeight();

            $( window ).smartresize( function() {
              //console.log( 'resizing' );
              $( '.menu-search-result' ).equalHeight();
            });

            posts[ 0 ].grand_total > 12 ? $( '#menu-search-pagination' ).show() : $( '#menu-search-pagination' ).hide();

          } else {

            Cookies.remove( 'search-term' );

            $( '#loading-search-results' ).hide();
            $( '.menu-search-pagination' ).hide();

            $( '#menu-search-results' ).html(
              '<p class="no-results">' + noResultsFound + '</p>'
            );

          }

        },
        error: function( response ) {
          console.log( response );
        }

      });

    });

    $( '#menu-search-pagination' ).click( function() {

      var that = $( this );

      $( that ).addClass( 'loading' );

      var $val = $( this ).data( 'val' );

      $val ? pagination += 12 : pagination = 0;

      $.ajax({

        method: 'POST',
        url: path + '/wp-admin/admin-ajax.php',
        data: {
          query: $val,
          offset: pagination,
          action: 'search_posts',
          security: $( '#search_nonce' ).val()
        },
        success: function( response ) {

          $( that ).removeClass( 'loading' );

          $( '#loading-search-results' ).hide();

          var posts = response.data.posts;

          console.log( posts );

          if ( posts.length > 0 ) {

            for ( var i = 0; i < posts.length; i++ ) {

              var $date = posts[ i ].date,
                $title = posts[ i ].title,
                $href = posts[ i ].href,
                $excerpt = posts[ i ].excerpt,
                $img = posts[ i ].img,
                $template = posts[ i ].template,
                $isLocation = posts[ i ].template === 'location.php' ? '<h6 class="eyebrow">Quad Location</h6>' : '';

              $( '#menu-search-results' ).append(

                '<div class="menu-search-result tile" data-pagination="' + pagination + '">' +
                //'<h6 class="eyebrow">'+ $date +'</h6>'+
                $isLocation +
                '<h4>' + $title + '</h4>' +
                '<p>' + $excerpt + '</p>' +
                '<a class="cta btn" href="' + $href + '"><span class="icon-right-circle"></span>Keep reading</a>' +
                '</div>'

              );

            }

            //var maxHeight = -1;

            $( '.menu-search-result' ).equalHeight();

            $( '.menu-search-result[data-pagination="' + pagination + '"]' ).each( function( index ) {

              //maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
              //$(this).height(maxHeight+60);

              var that = this;

              setTimeout( function() {
                $( that ).addClass( 'fadein' );
              }, ( index + 1 ) * 100 );

            });

            posts[ 0 ].grand_total > 12 ? $( '#menu-search-pagination' ).show() : $( '#menu-search-pagination' ).hide();

          }

          if ( posts.length > 0 && posts.length < 12 ) {

            $( '#menu-search-pagination' ).hide();

          }

        },
        error: function( response ) {
          console.log( response );
        }

      });

    });

    $( '.popular-searches a' ).click( function( event ) {

      event.preventDefault();

      var str = $( this ).text().replace( '"', '' );

      str = str.replace( '"', '' );

      $( '#search-input' ).val( str );

      $( 'form.search' ).submit();

      $( '.menu-section[data-menu="search"]' ).animate({ scrollTop: $( '#search-input' ).offset().top }, 1000 );

    });
  }

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return { init: _init };

})();
